import React, { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { UnsavedChangesModalProps } from './unsaved-changes-modal.models';
import { Modal } from '../modal';
import { Button } from '../button-new';
import { useStyles } from './unsaved-changes-modal.styles';
import { v2025PP16783 } from '../../../constants/veeva';

export const UnsavedChangesModal = ({
  pageName, title, content, rejectLabel, confirmLabel, onConfirm, onReject, onClose, rejectOnClose, ...props
}: UnsavedChangesModalProps,
): JSX.Element => {
  const typeId = pageName ? 'withPageName' : 'default';
  const classes = useStyles();
  const intl = useIntl();

  const handleConfirm = useCallback(() => {
    onConfirm();
  }, [onConfirm]);

  const handleReject = useCallback(() => {
    if (onReject) {
      onReject();
    } else {
      onClose!();
    }
  }, [onClose, onReject]);

  const handleClose = useCallback(() => {
    if (rejectOnClose && onReject) {
      onReject();
    } else {
      onClose!();
    }
  }, [onClose, rejectOnClose, onReject]);

  return (
    <Modal
      {...props}
      onClose={handleClose}
      veevaNumber={v2025PP16783}
      propsPaperStyles={classes.paperStyles}
      data-testid="unsaved-changes-modal"
      content={content ? content : (
        <>
          <h2 className={classes.title}>{title ? title : (
            intl.formatMessage({ id: 'unsavedChanges.modal.title' }, { noBreak: <>&nbsp;</> })
          )}</h2>
          <p className={classes.text}>
            <FormattedMessage id={`unsavedChanges.modal.description.${typeId}`} values={{ pageName }} />
          </p>
          <div className={classes.actions}>
             { /* Don't remove data-testid: it is used by Yandex Metrica. */ }
            <Button style="dark" data-testid="confirm" onClick={handleConfirm}>
              {confirmLabel
                ? confirmLabel
                : <FormattedMessage id="unsavedChanges.modal.confirmButton.label" />}
            </Button>
            { /* Don't remove data-testid: it is used by Yandex Metrica. */ }
            <Button style="outlined" data-testid="reject" onClick={handleReject}>
              {rejectLabel
                ? rejectLabel
                : <FormattedMessage id="unsavedChanges.modal.rejectButton.label" />}
            </Button>
          </div>
        </>
      )}
    />
  );
};
